import { render, staticRenderFns } from "./Company_oncall_duties.vue?vue&type=template&id=296e736f&scoped=true&lang=pug&"
import script from "./Company_oncall_duties.vue?vue&type=script&lang=coffee&"
export * from "./Company_oncall_duties.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e736f",
  null
  
)

export default component.exports